var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCopyStroke = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.846 10a.846.846 0 0 0-.846.846v8.308c0 .467.379.846.846.846h8.308a.846.846 0 0 0 .846-.846v-8.308a.846.846 0 0 0-.846-.846zM8 10.846A2.846 2.846 0 0 1 10.846 8h8.308A2.846 2.846 0 0 1 22 10.846v8.308A2.846 2.846 0 0 1 19.154 22h-8.308A2.846 2.846 0 0 1 8 19.154z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.846 4A.846.846 0 0 0 4 4.846v8.308a.846.846 0 0 0 .846.846h.923a1 1 0 1 1 0 2h-.923A2.846 2.846 0 0 1 2 13.154V4.846A2.846 2.846 0 0 1 4.846 2h8.308A2.846 2.846 0 0 1 16 4.846v.923a1 1 0 1 1-2 0v-.923A.846.846 0 0 0 13.154 4z",
  clipRule: "evenodd"
})));
export default SvgIcCopyStroke;